export enum AppRouteEnum {
  // Auth routes
  LOGIN = '/login',
  REGISTER = '/register',
  FORGOT_PASSWORD = '/forgot-password',
  CHANGE_PASSWORD = '/change-password',

  // Assets group
  ASSETS = '/assets',
  PORTFOLIO = '/portfolio',
  DEPOSIT_WITHDRAW = '/deposit-withdraw',

  // Order group
  ORDER = '/order',
  ORDER_HISTORY = '/order-history',

  // History group
  HISTORY = '/history',
  PNL = '/pnl',

  // Statement group
  STATEMENT = '/statement',
  STOCK_STATEMENT = '/stock-statement',
  WINLOSS_STATEMENT = '/winloss-statement',
  PORTFOLIO_STATEMENT = '/portfolio-statement',
  MONEY_STATEMENT = '/money-statement',

  // Menu group
  MENU = '/menu',
  SETTINGS = '/settings',
  PROFILE = '/profile',
  SMART_OTP_SETUP = '/smartotp/setup',
  NOTIFICATIONS = '/notifications',
  BANK_ACCOUNT_LIST = '/bank-account-list',
  BANK_ACCOUNT_EDIT = '/bank-account/:id',
  BANK_ACCOUNT_NEW = '/new-bank-account',
  PRODUCTS = '/products',
  PRODUCTS_DETAIL = '/products/:productId',
  MONEY_TRANSACTIONS = '/money-transactions',
  DEPOSIT = '/deposit',
  WITHDRAW = '/withdraw',
  INTERNAL_TRANSFER = '/internal-transfer',

  // Testing
  NOTIFICATION_TEST = '/notification-test',
}
